export const parkchirpStyles = {
	header: {
		backgroundColor: '#2a2f3c',
		color: '#333',
	},
	sidebar: {
		backgroundColor: '#2a2f3c',
		color: '#fff',
	},
	button: {
		backgroundColor: '#2F6690',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#428dbb',
		},
	},
	title: {
		color: '#fff',
	},
	text: {
		color: '#000000',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#343232',
		headerTextColor: '#FFFFFF',
	},
	platformName: {
		name: '',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/chirp/parkchirp-icon-car.svg',
			height: 45,
			width: 45,
		},
		large: {
			src: '/chirp/parkchirp-icon-car.svg',
			height: 45,
			width: 45,
		},
	},
	favicon: {
		src: '/chirp/parkchirp-icon-car.svg',
	},
	socials: {
		instagram: 'https://www.instagram.com/parkchirp',
		x: 'https://www.twitter.com/chirp_park',
		facebook: 'https://www.facebook.com/ParkChirp',
		linkedIn: 'https://www.linkedin.com/company/park-chirp',
	},
	orgName: 'ParkChirp LLC',
	siteUrl: 'https://parkchirp.com/',
	showLargeMenuIconButton: true,
};

export const parkchirpDarkStyles = {
	...parkchirpStyles,
	mode: 'dark',
	background: {
		default: '#1c2029',
	},
	icon: {
		color: 'white',
		'& .MuiIconButton-sizeSmall': {
			color: 'white !important',
		},
		'& .MuiIconButton-sizeMedium .MuiIconButton-edgeEnd': {
			color: 'white !important',
		},
		'&.MuiIconButton-sizeMedium': {
			color: 'white !important',
		},
	},
	dataGrid: {
		background: '#2a2f3c',
	},
	dataGridToolbar: {
		background: '#2a2e3c',
		borderBottom: '1px solid #00000000',
	},
	text: {
		color: '#ffffff',
	},
	paper: {
		backgroundImage: 'initial',
		backgroundColor: '#2a2e3c',
		border: '1px solid #515151',
	},
	table: {
		backgroundColor: '#2a2e3c',
		headerBackgroundColor: '#2a2e3c',
		headerTextColor: '#FFFFFF',
	},
};
